import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { baseProductSlug } = useLocalSearchParams<{
    baseProductSlug: string;
  }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Change Location — {baseProductSlug}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton
        href={`/(modals)/product-details/${baseProductSlug}` as never}
        dismiss
      />
    </ExpoRouterDemoScreen>
  );
}
